import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/fields'
import { CircleLoader } from 'components/loaders/index'
import styles from './input-search.styl'

class InputSearch extends Component {
  static propTypes = {
    isLoading: PropTypes.bool
  }

  render() {
    const { isLoading } = this.props

    return (
      <div className={styles.wrap}>
        <Input
          type="search"
          name="searchQuery"
          {...this.props}
          className={styles.input}
        />
        {isLoading ? (
          <div className={styles.loader}>
            <CircleLoader size={50} />
          </div>
        ) : (
          <button type="submit" className={styles.submit} />
        )}
      </div>
    )
  }
}

export default InputSearch
